import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/Warehouse/ShoppingMall/';

const state = {
  ClassList: [],
  GoodsList: [],
  SingleGoodsList: [],
  SellList: [],
  Cart: []
};

const mutations = {
  setCart(state, view) {
    main.localStorage.save('ShoppingMallCart', view);
    state.Cart = view;
  },
  setCacheCart(state, view) {
    state.Cart = view;
  },
  setClassList(state, view) {
    state.ClassList = view.list;
  },
  setGoodsList(state, view) {
    state.GoodsList = view.list;
  },
  setSingleGoodsList(state, view) {
    state.SingleGoodsList = view.list;
  },
  setSellList(state, view) {
    var sgoods = [];
    var goods = [];
    var clazz = [];
    //
    main.utils.each(main.utils.clone(view), function () {
      main.utils.each(main.utils.clone(this.GoodsList), function () {
        main.utils.each(main.utils.clone(this.SingleGoodsList), function () {
          sgoods.push(this);
        });
        delete this.SingleGoodsList;
        goods.push(this);
      });
      delete this.GoodsList;
      clazz.push(this);
    });
    state.ClassList = clazz;
    state.GoodsList = goods;
    state.SingleGoodsList = sgoods;
    state.SellList = view;
  },
};

const actions = {
  GetSellList({commit}, view) {
    var that = this;
    return new Promise((resolve, reject) => {
      if (that.getters.ShoppingMall_SellList.length === 0) {
        request.PromiseCall(basePath, 'GetSellList', view).then((res) => {
          commit('setSellList', res);
          resolve();
        }).catch(() => {
          reject();
        });
      } else {
        resolve();
      }
    });
  },
  CheckAllGoods({commit}, view) {
    var that = this;
    if (that.getters.ShoppingMall_GoodsList.length === 0) {
      that.dispatch('Function/Warehouse/ShoppingMall/CheckGoods', {
        params: {
          ThisPage: 0,
          PageNum: -1
        },
      }).then((res) => {
        commit('setGoodsList', res);
      });
    }
  },
  CheckAllClass({commit}, view) {
    var that = this;
    if (that.getters.ShoppingMall_ClassList.length === 0) {
      that.dispatch('Function/Warehouse/ShoppingMall/CheckClass', {
        params: {
          ThisPage: 0,
          PageNum: -1
        },
      }).then((res) => {
        commit('setClassList', res);
      });
    }
  },
  // ===========================================================================
  setCart({commit}, view) {
    commit('setCart', view);
  },
  setCacheCart({commit}, view) {
    commit('setCacheCart', view);
  },
  // ===========================================================================
  GetSingleGoods({commit}, view) {
    return request.PromiseCall(basePath, 'GetSingleGoods', view);
  },
  CheckClass({commit}, view) {
    return request.PromiseCall(basePath, 'CheckClass', view);
  },
  CheckGoods({commit}, view) {
    return request.PromiseCall(basePath, 'CheckGoods', view);
  },
  Booking({commit}, view) {
    return request.PromiseCall(basePath, 'Booking', view);
  },
  SetOrderEnabled({commit}, view) {
    return request.PromiseCall(basePath, 'SetOrderEnabled', view);
  },
  AddPayLog({commit}, view) {
    return request.PromiseCall(basePath, 'AddPayLog', view);
  },
  GetOrderInTree({commit}, view) {
    return request.PromiseCall(basePath, 'GetOrderInTree', view);
  },
  CheckSingleGoods({commit}, view) {
    return request.PromiseCall(basePath, 'CheckSingleGoods', view);
  },


};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Warehouse/ShoppingMall/index.js